var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRedo = function SvgRedo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6A89A6",
    fillRule: "evenodd",
    d: "M18.793 10.707a1 1 0 0 1 1.414-1.414l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L20.086 14H14a3 3 0 1 0 0 6h5.913a1 1 0 1 1 0 2H14a5 5 0 0 1 0-10h6.086l-1.293-1.293Z",
    clipRule: "evenodd"
  })));
};
export default SvgRedo;